const KEY = 'household_id'

// A plain localStorage-backed module, not a React context, so the axios interceptor (outside
// the component tree) can read it without hooks.
export const currentHousehold = {
  get(): string | null {
    return localStorage.getItem(KEY)
  },
  set(id: string) {
    localStorage.setItem(KEY, id)
  },
  clear() {
    localStorage.removeItem(KEY)
  },
}
